export default __webpack_public_path__ + "media/images/1-c14542b5baf5413d14bf229fbca0eb18.jpg";